import React from 'react';

export const NavbarContext = React.createContext({});
